'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  padding-left: 15px;\n'], ['\n  padding-left: 15px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    ', '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    border-radius: ', ';\n'], ['\n    ', '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    border-radius: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _alignments = require('../../../constants/alignments');

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _separator = require('../../../atoms/separator');

var _separator2 = _interopRequireDefault(_separator);

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _input = require('../../../atoms/input');

var _input2 = _interopRequireDefault(_input);

var _isValidPhoneNumber = require('../../../helpers/isValidPhoneNumber');

var _isValidPhoneNumber2 = _interopRequireDefault(_isValidPhoneNumber);

var _getFieldValidationInfo = require('../../../helpers/getFieldValidationInfo');

var _getFieldValidationInfo2 = _interopRequireDefault(_getFieldValidationInfo);

var _getTooltip = require('../../../helpers/getTooltip');

var _getTooltip2 = _interopRequireDefault(_getTooltip);

var _grid = require('../../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _error = require('../../../atoms/icons/error');

var _error2 = _interopRequireDefault(_error);

var _tooltip = require('../../tooltip2');

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PhoneContainer = _styledComponents2.default.div(_templateObject);

var ValidationBanner = _styledComponents2.default.div(_templateObject2, function (_ref) {
    var type = _ref.type;
    return type === 'error' ? 'background: rgba(255, 0, 78, .15);' : type === 'warning' ? 'background: rgba(255, 129, 0, .15);' : null;
}, function (_ref2) {
    var index = _ref2.index,
        labelValue = _ref2.labelValue;
    return index === 0 && labelValue ? '0 0 4px 4px' : '4px';
});

var FormFullPhoneNumber = function (_React$Component) {
    _inherits(FormFullPhoneNumber, _React$Component);

    function FormFullPhoneNumber() {
        var _ref3;

        var _temp, _this, _ret;

        _classCallCheck(this, FormFullPhoneNumber);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = FormFullPhoneNumber.__proto__ || Object.getPrototypeOf(FormFullPhoneNumber)).call.apply(_ref3, [this].concat(args))), _this), _this.getFormattedPhoneNumber = function (value) {
            if (!value) return value;
            var phoneNumber = value.replace(/[^\d]/g, '');
            var phoneNumberLength = phoneNumber.length;
            if (phoneNumberLength < 4) return phoneNumber;
            if (phoneNumberLength < 7) {
                return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3);
            }
            return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
        }, _this.handleReturn = function (value) {
            var pureNumber = value.replace(/\D/g, '').slice(0, 10);
            _this.props.sectionUIValidation(_defineProperty({}, _this.props.position, pureNumber ? (0, _isValidPhoneNumber2.default)(pureNumber) : true));
            _this.props.changeEvent(pureNumber);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FormFullPhoneNumber, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.sectionUIValidation && this.props.position) {
                this.props.sectionUIValidation(_defineProperty({}, this.props.position, this.props.value ? (0, _isValidPhoneNumber2.default)(this.props.value) : true));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var editMode = this.props.editing && this.props.allowEdit;

            var _getFieldValidationIn = (0, _getFieldValidationInfo2.default)(this.props.validationInfo, this.props.pageCode, this.props.sectionCode, this.props.fieldCode, this.props.rowId),
                errors = _getFieldValidationIn.errors,
                warnings = _getFieldValidationIn.warnings;

            var labelValue = this.getFormattedPhoneNumber(this.props.value || '');

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_separator2.default, { bottom: _sizes.Sizes.sm, orientation: 'horizontal', solid: true }),
                _react2.default.createElement(
                    _grid2.default,
                    null,
                    _react2.default.createElement(
                        _row2.default,
                        null,
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 5, nogutter: true },
                            _react2.default.createElement(
                                _container2.default,
                                { inline: true, verticalAlignment: _alignments.Alignments.center },
                                _react2.default.createElement(_label2.default, { bold: true, textAlign: _alignments.Alignments.left, text: this.props.label }),
                                this.props.pageCode && this.props.sectionCode && this.props.fieldCode && _react2.default.createElement(_tooltip2.default, {
                                    header: this.props.label,
                                    text: (0, _getTooltip2.default)(this.props.tooltipInfo, this.props.pageCode, this.props.sectionCode, this.props.fieldCode),
                                    saveHandler: this.props.saveTooltipInfo,
                                    reduceHandler: function reduceHandler() {
                                        return function (value) {
                                            _this2.props.reduceTooltipInfoElement({
                                                newTooltip: value,
                                                pageCode: _this2.props.pageCode,
                                                sectionCode: _this2.props.sectionCode,
                                                fieldCode: _this2.props.fieldCode
                                            });
                                        };
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(_column2.default, { xs: 1 }),
                        editMode && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            _react2.default.createElement(
                                _column2.default,
                                { xs: 6, nogutter: true },
                                _react2.default.createElement(_input2.default, {
                                    type: 'Phone',
                                    placeholder: this.props.placeholder,
                                    value: labelValue,
                                    changeEvent: function changeEvent(value) {
                                        return _this2.handleReturn(value);
                                    },
                                    error: this.props.value && !(0, _isValidPhoneNumber2.default)(this.props.value) && errors.length > 0,
                                    serverErrors: errors,
                                    serverWarnings: warnings,
                                    sectionUIValidation: this.props.sectionUIValidation
                                })
                            )
                        ),
                        !editMode && _react2.default.createElement(
                            _column2.default,
                            { xs: 6, nogutter: true },
                            _react2.default.createElement(
                                PhoneContainer,
                                null,
                                _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left, text: this.props.value && this.getFormattedPhoneNumber(this.props.value || '') })
                            ),
                            errors.length > 0 && errors.map(function (error, index) {
                                return _react2.default.createElement(
                                    ValidationBanner,
                                    { key: index, type: 'error', index: index, labelValue: labelValue },
                                    _react2.default.createElement(_error2.default, { mode: 'error', size: 24 }),
                                    _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left, text: error.message, color: _colors.Colors.Error })
                                );
                            }),
                            warnings.length > 0 && warnings.map(function (warning, index) {
                                return _react2.default.createElement(
                                    ValidationBanner,
                                    { key: index, type: 'warning', index: index, labelValue: labelValue },
                                    _react2.default.createElement(_error2.default, { mode: 'warning', size: 24 }),
                                    _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left, text: warning.message, color: _colors.Colors.Warning })
                                );
                            })
                        )
                    )
                )
            );
        }
    }]);

    return FormFullPhoneNumber;
}(_react2.default.Component);

exports.default = FormFullPhoneNumber;